<extra-information [tipContent]="'financial-obligations.credit-card.tip' | apContent"></extra-information>

<next-button (click)="nextQuestion()"></next-button>
